import { Box } from '@mui/material';

/**
 * Renders a "Skip to main content" link that appears only on keyboard focus.
 * Positioned absolutely so it doesn't disrupt the visual design, but sits at
 * the top of the tab order for keyboard users.
 */
export function SkipToContent({ targetId }: { targetId: string }) {
  return (
    <Box
      component="a"
      href={`#${targetId}`}
      sx={(t) => ({
        position: 'fixed',
        top: 8,
        left: 8,
        zIndex: t.zIndex.modal + 1,
        px: 2,
        py: 1,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: 1,
        fontWeight: 500,
        textDecoration: 'none',
        transform: 'translateY(-200%)',
        transition: 'transform 120ms ease',
        '&:focus': { transform: 'translateY(0)' },
      })}
    >
      Skip to main content
    </Box>
  );
}
